{#if status === 'withdrawn'}
  <span class="tag is-info is-light is-danger" class:is-medium={medium}>
    request withdrawn
  </span>
{:else if status === 'unsuccessful'}
  <span class="tag is-light" class:is-medium={medium}> 
    request declined 
  </span>
{:else if status === 'new'}
  <span class="tag is-success is-light is-success" class:is-medium={medium}>
    request made
  </span>
{:else if status === 'selected'}
  <span class="tag is-info is-light" class:is-medium={medium}>
    selected - awaiting confirmation
  </span>
{:else if status === 'interested'}
  <span class="tag is-info is-light" class:is-medium={medium}>
    expressed interest
  </span>
{:else if status === 'matched'}
  <span class="tag is-info is-light" class:is-medium={medium}>
    matched - donation pending
  </span>
{:else if status === 'completed'}
  <span class="tag is-info is-light" class:is-medium={medium}>
    matched - donation complete
  </span>
{:else if status === 'failed'}
  <span class="tag is-danger is-light" class:is-medium={medium}>
    matched - donation abandoned
  </span>
{:else}
  <span />
{/if}

<script lang="ts">
  export let status: RequestStatus,
    medium: boolean = false;
</script>
